<template>
    <div class="HomeHionAdm">
        <PageTitle icon="fas fa-user-lock iconInterativoTitulo" main="PLATAFORMA ADMINISTRATIVA HION"
            sub="Dashboard Interativo" />

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
//import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
//import { baseApiUrl, userKey, showError } from '../../../global'
//import axios from 'axios'

export default {
    name: 'HomeHionAdm',
    components: { PageTitle } ,
    data: function() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style>
    .HomeHionAdm {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>